"use client";

import { createRestDataProviderClient } from "@providers/data-provider/rest-data-provider.client";
import { isFilterValueExist, parseFilter, transformQueryParamsWithoutLocale } from "@shared/utils";
import { Checkbox, ComboboxOption } from "@ubud-ui/react-ui-kit";
import { useQuery } from "@tanstack/react-query";
import { useRouter, useSearchParams } from "next/navigation";
import qs from "qs";
import { useState } from "react";

type JobType = {
  id: string;
  name: string;
};

const FILTER_KEY = "jobTypes";

export function JobTypeFilter({ path }: { path: string }) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const restDataProviderClient = createRestDataProviderClient();

  const [keyword, setKeyword] = useState<string>("");
  const { data: optionResult } = useQuery<{ data: JobType[] }>({
    queryKey: ["vacancy-job-type-filter-", keyword],
    queryFn: () =>
      restDataProviderClient.custom({
        url: transformQueryParamsWithoutLocale(
          "/karirhub/v1/job-types",
          keyword
            ? {
                keyword: keyword,
                limit: 5,
              }
            : {
                limit: 5,
              },
        ),
        method: "GET",
      }),
  });
  const options: ComboboxOption[] = optionResult?.data
    ? optionResult?.data?.map((it) => {
        return {
          value: it.id,
          label: it.name,
        };
      })
    : [];

  const handleSearch = (keyword: string) => {
    setKeyword(keyword);
  };

  const handleFilter = (option: ComboboxOption, checked: boolean) => {
    const paramsString = searchParams.toString();

    const value = {
      id: option.value,
      label: option.label,
    };

    const params = parseFilter(FILTER_KEY, value, qs.parse(paramsString), checked);

    router.push(`${path}?${qs.stringify(params, { skipNulls: true })}`, {
      scroll: false,
    });
  };

  const isChecked = (value: string) => {
    const params = qs.parse(searchParams.toString());

    return isFilterValueExist(params, FILTER_KEY, value);
  };

  return (
    <>
      {options && options.length > 0 ? (
        <div className="space-y-3 pb-2">
          {options.map((option, index) => {
            return (
              <div className="flex items-start gap-3" key={option.value + "-" + index}>
                {isChecked(option.value)}
                <Checkbox
                  className="mt-1"
                  id={option.value + "-" + index}
                  onCheckedChange={(checked) => handleFilter(option, checked as boolean)}
                  checked={isChecked(option.value)}
                />
                <label htmlFor={option.value + "-" + index}>{option.label}</label>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center font-bold pt-5 pb-2">
          {!keyword ? "Ketik untuk mencari tipe pekerjaan" : "Tipe pekerjaan tidak ditemukan"}
        </div>
      )}
    </>
  );
}
